import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noMatchValidator(sourceName: string, destinationName: string): (group: AbstractControl) => ValidationErrors | null {
  return (group: AbstractControl): ValidationErrors | null => {
    const sourceControl: AbstractControl = group.get(sourceName);
    const destinationControl: AbstractControl = group.get(destinationName);

    if (destinationControl.errors && !destinationControl.errors.noMatch) {
      return null;
    }

    if (sourceControl.value === destinationControl.value || JSON.stringify(sourceControl.value) === JSON.stringify(destinationControl.value)) {
      destinationControl.setErrors({ noMatch: true });
      return destinationControl.errors;
    }
    destinationControl.setErrors(null);
    return null;
  };
}
